import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOMeta from '@/components/feature/SEOMeta';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import FeaturedVideos from '@/pages/home/components/FeaturedVideos';
import StatsSection from '@/pages/home/components/StatsSection';
import FAQSection from '@/pages/home/components/FAQSection';
import DownloadCTA from '@/pages/home/components/DownloadCTA';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: '紅桃視頻',
      url: 'https://hongtao.video',
      description: '高清短視頻平台，海量內容免費看',
    },
    {
      '@type': 'WebSite',
      name: '紅桃視頻',
      url: 'https://hongtao.video',
      potentialAction: {
        '@type': 'SearchAction',
        target: 'https://hongtao.video/search?q={search_term_string}',
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'WebPage',
      name: '紅桃視頻 - 首頁',
      description: '紅桃視頻是一款高清短視頻平台，提供海量精選視頻內容，涵蓋娛樂、生活、搞笑、美食等多種分類。',
      url: 'https://hongtao.video',
      isPartOf: { '@type': 'WebSite', name: '紅桃視頻', url: 'https://hongtao.video' },
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '紅桃視頻是免费的嗎？',
          acceptedAnswer: { '@type': 'Answer', text: '是的，紅桃視頻完全免费！所有视频内容均可免费观看，无需任何付费。' },
        },
        {
          '@type': 'Question',
          name: '紅桃視頻支持哪些设备？',
          acceptedAnswer: { '@type': 'Answer', text: '紅桃視頻支持iOS和Android系统的手机和平板设备。' },
        },
        {
          '@type': 'Question',
          name: '如何成为紅桃視頻的创作者？',
          acceptedAnswer: { '@type': 'Answer', text: '下载紅桃視頻App后，注册账号即可开始创作，享受完善的创作者扶持计划。' },
        },
        {
          '@type': 'Question',
          name: '视频画质最高支持多少？',
          acceptedAnswer: { '@type': 'Answer', text: '紅桃視頻支持最高4K超高清画质播放，会根据网络状况自动调整画质。' },
        },
        {
          '@type': 'Question',
          name: '遇到问题如何联系客服？',
          acceptedAnswer: { '@type': 'Answer', text: '在App内点击"我的-帮助与反馈"提交问题，或发送邮件至support@hongtao.video。' },
        },
        {
          '@type': 'Question',
          name: '紅桃視頻的推荐算法是怎样的？',
          acceptedAnswer: { '@type': 'Answer', text: '采用自研智能推荐算法，综合考虑观看历史、点赞、收藏、完播率等行为数据，精准推荐。' },
        },
      ],
    },
  ],
};

export default function Home() {
  return (
    <>
      <SEOMeta
        title="紅桃視頻 - 高清短視頻平台，海量內容免費看"
        description="紅桃視頻是一款高清短視頻平台，提供海量精選視頻內容，涵蓋娛樂、生活、搞笑、美食等多種分類。立即訪問紅桃視頻，享受流暢播放體驗，隨時隨地暢享優質視頻內容，下載App免費使用。"
        keywords="紅桃視頻,紅桃視頻App下載,紅桃視頻官網,紅桃短視頻,紅桃視頻高清播放,紅桃視頻免費看,紅桃視頻最新版本"
        canonicalUrl="https://hongtao.video"
      />
      <SchemaOrg type="WebPage" data={homeSchema} />

      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main>
          <HeroSection />
          <CategoryGrid />
          <FeaturedVideos />
          <StatsSection />
          <FAQSection />
          <DownloadCTA />
        </main>
        <Footer />
      </div>
    </>
  );
}